module.exports = __webpack_public_path__ + "img/POI.eaa15942.svg";